// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

class Browser {
    // For CSS
    static chrome = "@media screen and (-webkit-min-device-pixel-ratio:0)";
    static ie = "@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none)";
    static edge = "@supports (-ms-ime-align:auto)";
    static firefox = "@-moz-document url-prefix()";

    // For JS
    static getUserAgent = () => navigator.userAgent;

    static isChrome = () => Browser.getUserAgent().indexOf("Chrome") !== -1;
    static isIE = () => Browser.getUserAgent().indexOf("MSIE") !== -1;
    static isSafari = () => Browser.getUserAgent().indexOf("Safari") !== -1;
    static isFirefox = () => Browser.getUserAgent().indexOf("Firefox") !== -1;
}

export default Browser;
